const initialState = {
    items: [],
    single: {},
    refresh: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
            if (!action.payload.pathname.startsWith('/workspace/')) {
                return {
                    ...state,
                    single: {}
                };
            } else {
                return state;
            }
        case 'HIDE_SUB_BAR':
            return {
                ...state,
                single: {}
            };
        case 'MENU_SINGLE_SUCCESS':
            return {
                ...state,
                single: action.payload.data
            };
        case 'MENU_GET_SUCCESS':
            return {
                ...state,
                items: action.payload.data
            };
        case 'MENU_REFRESH_TRUE':
            return {
                ...state,
                refresh: true
            };
        case 'MENU_REFRESH_FALSE':
            return {
                ...state,
                refresh: false
            };
        case 'MENUS':
            return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/menu.js